import './ToastContainer.css';
import { Toast } from '../Toast';
import { useToastStore, useToast } from '../../../../stores/toastStore';

export function ToastContainer() {
  const { toasts } = useToastStore();
  const { removeToast } = useToast();

  return (
    <div
      className="toast-container"
      aria-live="polite"
      aria-atomic="false"
      data-testid="toast-container"
    >
      {toasts.map((toast) => (
        <Toast
          key={toast.id}
          toast={toast}
          onDismiss={removeToast}
        />
      ))}
    </div>
  );
}
